import {
  AccountType,
  CalculationResults,
  PixOrBankSlipInfo,
  SignUpStep,
  UserAddress,
} from "./types";

export type SignUpReducerState = {
  step: SignUpStep;
  calculationResults?: CalculationResults;
  signUpStep: number;
  userAccount?: AccountType;
  userAddress?: UserAddress;
  pixOrBankSlipInfo?: PixOrBankSlipInfo;
  paymentSucceeded?: boolean;
  createdUserData?: { id: string; access_token: string };
};

export type SignUpReducerAction =
  | {
      type: "step";
      stepPayload: SignUpReducerState["step"];
    }
  | {
      type: "calculationResults";
      calculationResultsPayload: SignUpReducerState["calculationResults"];
    }
  | {
      type: "signUpStep";
      signUpStepPayload: SignUpReducerState["signUpStep"];
    }
  | {
      type: "userAccount";
      userAccountPayload: SignUpReducerState["userAccount"];
    }
  | {
      type: "userAddress";
      userAddressPayload: SignUpReducerState["userAddress"];
    }
  | {
      type: "pixOrBankSlipInfo";
      pixOrBankSlipInfoPayload: SignUpReducerState["pixOrBankSlipInfo"];
    }
  | {
      type: "paymentSucceeded";
      paymentSucceededPayload: SignUpReducerState["paymentSucceeded"];
    }
  | {
      type: "createdUserData";
      createdUserDataPayload: SignUpReducerState["createdUserData"];
    };

export const reducerSignUp = (
  state: SignUpReducerState,
  action: SignUpReducerAction
): SignUpReducerState => {
  switch (action.type) {
    case "step":
      return { ...state, step: action.stepPayload };
    case "calculationResults":
      return { ...state, calculationResults: action.calculationResultsPayload };
    case "signUpStep":
      return { ...state, signUpStep: action.signUpStepPayload };
    case "userAccount":
      return { ...state, userAccount: action.userAccountPayload };
    case "userAddress":
      return { ...state, userAddress: action.userAddressPayload };
    case "pixOrBankSlipInfo":
      return { ...state, pixOrBankSlipInfo: action.pixOrBankSlipInfoPayload };
    case "paymentSucceeded":
      return { ...state, paymentSucceeded: action.paymentSucceededPayload };
    case "createdUserData":
      return { ...state, createdUserData: action.createdUserDataPayload };
  }
};
